import React from 'react';

// eslint-disable-next-line import/named
import { TranslateFunction } from 'react-localize-redux';

import { Typography } from '../../../components/atoms/Typography';
import { Page } from '../../../components/layouts';

type OrderCompleteErrorProps = {
  error: Error;
  translate: TranslateFunction;
};

export function OrderCompleteError(
  props: OrderCompleteErrorProps,
): JSX.Element {
  const { error, translate } = props;

  return (
    <Page pageName="order-confirmation" noLayout>
      <Typography variant="h3">
        {translate(error.message, undefined, {
          missingTranslationMsg: error.message,
        })}
      </Typography>
    </Page>
  );
}
